import api from "@/lib/api";

// Separate IndexedDB (getrennt von der Offline-Queue csp-offline) für Referenzdaten.
const DB = "csp-refcache";
const STORE = "kv";
const V = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, V);
    req.onupgradeneeded = () => { const db = req.result; if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: "k" }); };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function idbSet(k, v) {
  const db = await openDb();
  return new Promise((res) => { const tx = db.transaction(STORE, "readwrite"); tx.objectStore(STORE).put({ k, v }); tx.oncomplete = () => res(true); tx.onerror = () => res(false); });
}

async function idbGet(k) {
  const db = await openDb();
  return new Promise((res) => { const tx = db.transaction(STORE, "readonly"); const rq = tx.objectStore(STORE).get(k); rq.onsuccess = () => res(rq.result ? rq.result.v : undefined); rq.onerror = () => res(undefined); });
}

// GET mit automatischem Offline-Cache: online → speichern & zurückgeben; offline → aus Cache.
export async function cachedGet(path) {
  try {
    const r = await api.get(path);
    idbSet("GET:" + path, r.data);
    return r.data;
  } catch (e) {
    if (!navigator.onLine || (e && e.isAxiosError && !e.response)) {
      const cached = await idbGet("GET:" + path);
      if (cached !== undefined) return cached;
    }
    throw e;
  }
}

// Fotos proaktiv in den (vom Service Worker verwalteten) Cache holen.
async function prefetchMedia(ids) {
  const uniq = Array.from(new Set(ids.filter(Boolean)));
  let ok = 0;
  for (const id of uniq) {
    try { await api.get(`/media/${id}/thumbnail`, { responseType: "blob" }); ok += 1; } catch (e) { /* ignore */ }
  }
  return ok;
}

// Bereitet einen Standort (alle Anlagen desselben site_id) vollständig für den Offline-Einsatz vor.
export async function prepareSite(asset, allAssets, onProgress) {
  const siteId = asset?.site_id;
  const siteAssets = siteId ? (allAssets || []).filter((a) => a.site_id === siteId) : (allAssets || []);
  onProgress && onProgress("Kataloge …");
  await Promise.all([
    cachedGet("/assets"),
    cachedGet("/v1/catalogs/component-categories"),
    cachedGet("/v1/catalogs/component-types"),
    cachedGet("/v1/catalogs/component-option-lists"),
  ].map((p) => p.catch(() => null)));

  const mediaIds = [];
  const kinds = new Set();
  for (let i = 0; i < siteAssets.length; i++) {
    const a = siteAssets[i];
    onProgress && onProgress(`Anlage ${i + 1}/${siteAssets.length} …`);
    try {
      const comps = await cachedGet(`/v1/assets/${a.id}/components`);
      (comps || []).forEach((c) => { if (c.typenschild_media_id) mediaIds.push(c.typenschild_media_id); if (c.kind) kinds.add(c.kind); });
    } catch (e) { /* ignore */ }
  }
  onProgress && onProgress("Prüf-Checklisten …");
  await Promise.all(Array.from(kinds).map((k) => cachedGet(`/v1/checkpoints?kind=${k}`).catch(() => null)));
  onProgress && onProgress("Fotos …");
  const media = await prefetchMedia(mediaIds);

  const stamp = { at: Date.now(), assets: siteAssets.length, media };
  idbSet("prepared:" + (siteId || "all"), stamp);
  return stamp;
}

export async function getPreparedStamp(siteId) {
  return idbGet("prepared:" + (siteId || "all"));
}
